export interface TourSupportType {
    advance_img: string;
    logo: string;
    name: string;
    photo: string;
}

export const NO_TOUR_SUPPORT = 'No Tour Support';
